import React from 'react';
import { Link } from 'gatsby';
import ContainerContent from '../3_layouts/ContainerContent';
import IconCopyright from '../5_assets/svg/icons/copyright.svg';
import IconLinkedin from '../5_assets/svg/icons/linkedin.svg';
import IconInstagram from '../5_assets/svg/icons/instagram.svg';
import IconMail from '../5_assets/svg/icons/mail-fill.svg';
import { CONTACT_EMAIL } from '../constants/contact';

const footerLinks = [
   { label: 'Case studies', to: '/#work', aria: 'Link to work section' },
   { label: 'About', to: '/#about', aria: 'Link to about section' },
   { label: 'Recommendations', to: '/#recommendations', aria: 'Link to recommendations section' },
   { label: 'Contact', to: '/#contact', aria: 'Link to contact section' },
];

const socialIcons = [
   { href: 'https://www.linkedin.com/in/paolo-todde/', icon: IconLinkedin, label: 'LinkedIn' },
   // { href: 'https://www.instagram.com/paolo__todde/', icon: IconInstagram, label: 'Instagram' },
   { href: `mailto:${CONTACT_EMAIL}`, icon: IconMail, label: 'Email' },
];

const FooterLink = ({ to, label, aria, textClasses }) => (
   <li aria-label={aria}>
      <Link to={to} title={label}>
         <p className={`${textClasses} text-link uppercase `}>{label}</p>
      </Link>
   </li>
);

const SocialIcon = ({ href, icon: Icon, label, textClasses }) => (
   <li className="group">
      <a title={label} aria-label={`${label} icon`} href={href} target="_blank" rel="noopener noreferrer">
         <Icon alt={`${label} icon`} className={`w-4 ${textClasses}`} />
      </a>
   </li>
);

const ExternalLink = ({ href, label, children, textClasses }) => (
   <a
      className={`${textClasses} text-link`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Link to ${label}`}
   >
      {children}
   </a>
);

const Footer = ({ pathname }) => {
   const isHomePage = pathname === '/';
   const currentYear = new Date().getFullYear();
   const textClasses = `body-sm ${isHomePage ? 'text-body-secondary--bright' : 'text-body-primary--dark'}`;

   return (
      <footer className=" overflow-hidden space-bottom-lg space-top-lg" role="group" aria-label="Footer">
         <ContainerContent>
            <div className={`flex flex-col md:flex-row justify-between space-y-8 text-center md:text-left`}>
               <div className="flex flex-col space-y-3 lg:p-0 items-center md:items-start">
                  <p className={`${textClasses}`}>
                     Designed in{' '}
                     <ExternalLink href="https://www.figma.com/" label="Figma" textClasses={textClasses}>
                        Figma
                     </ExternalLink>
                  </p>
                  <p className={`${textClasses}`}>
                     Coded with{' '}
                     <ExternalLink href="https://www.gatsbyjs.com/" label="Gatsby" textClasses={textClasses}>
                        Gatsby.js
                     </ExternalLink>
                  </p>
                  <p className={`${textClasses}`}>
                     Styled with{' '}
                     <ExternalLink href="https://tailwindcss.com/" label="Tailwindcss" textClasses={textClasses}>
                        Tailwind CSS
                     </ExternalLink>
                  </p>
                  <p className={`${textClasses}`}>
                     Animated with{' '}
                     <ExternalLink href="https://www.react-spring.dev/" label="React spring" textClasses={textClasses}>
                        React Spring
                     </ExternalLink>{' '}
                     and{' '}
                     <ExternalLink href="https://www.reactbits.dev/" label="React spring" textClasses={textClasses}>
                        React Bits
                     </ExternalLink>
                  </p>
                  <div className={`${textClasses} flex items-center space-x-1`}>
                     <IconCopyright className="inline-flex h-full w-5 md:mr-1" />
                     <p className={`${textClasses}`}>{currentYear}</p>
                  </div>
               </div>

               <ul className="flex justify-center space-x-8">
                  {socialIcons.map((icon, index) => (
                     <SocialIcon key={index} {...icon} textClasses={textClasses} />
                  ))}
               </ul>
               <ul className="flex flex-col md:items-start space-y-2">
                  {footerLinks.map((link, index) => (
                     <FooterLink key={index} {...link} textClasses={textClasses} />
                  ))}
               </ul>

            </div>
         </ContainerContent>
      </footer>
   );
};

export default Footer;
